<app-auth-container>
  @if (wasSent) {
    <p class="auth__title mb-3">{{ 'auth.sent' | translate }}</p>
    <p class="auth__descr">{{ 'auth.receivedEmailWithButton' | translate }}</p>

    <p class="auth__descr auth__descr--color-black" [innerHTML]="'auth.recoverStep.first' | translate: { email: this.form.get('email').value }"></p>
    <p class="auth__descr auth__descr--color-black" [innerHTML]="'auth.recoverStep.second' | translate"></p>

    @if (secondChance) {
      <a href="/recuperar-senha" class="auth__link mt-3 mb-4">{{ 'auth.notReceivedEmail' | translate }}</a>
    } @else {
      <a (click)="sendSecondChance()" class="auth__link mt-3 mb-4">{{ 'button.resendEmail' | translate }}</a>
    }
  } @else {
    <p class="auth__title">{{ 'auth.recoverPassword' | translate }}</p>
    <p class="auth__descr">{{ 'auth.fillEmailToRecoverPassword' | translate }}</p>

    <form class="field__form" (ngSubmit)="sendPasswordConfirmation()" [formGroup]="form" novalidate>
      <label class="field__holder" [appFormControlWrap]="form.get('email')">
        <input type="email" class="field" formControlName="email" name="email" autocomplete="email" required appValidEmail />
        <span class="field__placeholder">{{ 'auth.emailToRecoverPassword' | translate }}</span>
      </label>

      <div class="submit-holder mt-3">
        <button type="submit" class="submit" [disabled]="form.invalid || isLoading">{{ 'button.send' | translate }}</button>
        <button type="button" routerLink="/entrar" queryParamsHandling="preserve" class="back btn-L btn-text">{{ 'button.back' | translate }}</button>
      </div>
    </form>
  }
</app-auth-container>
